import styled from 'styled-components';

const Logo = styled.img`
  padding: 12px 24px;
  box-sizing: content-box;
  max-width: 140px;
  margin: 0 auto;
`;
const ItemText = styled.span`
  font-weight: 600;
  font-size: 13.5px;
  line-height: 1.2;
  flex: 1;
  min-width: 0;
`;

const Blinking = styled.svg`
  -webkit-animation: 1s blink ease infinite;
  -moz-animation: 1s blink ease infinite;
  -ms-animation: 1s blink ease infinite;
  -o-animation: 1s blink ease infinite;
  animation: 1s blink ease infinite;
  width: 10px;
  height: 10px;

  @keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-moz-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-webkit-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-ms-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-o-keyframes blink {
    from,
    to {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
`;

const LogoWrapper = styled.div`
  background-color: #fff;
  border-radius: 12px;
  margin: 12px 15px 10px;
  display: flex;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05);
`;

const NavDivider = styled.hr`
  border: none;
  border-top: 1px solid #ebebeb;
  margin: 0;
  width: 100%;
`;

const NewBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  background-color: #ff3c3c;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  margin-left: auto;
  flex-shrink: 0;
  line-height: 1;

  svg {
    font-size: 11px;
    width: 11px;
    height: 11px;
    display: block;
  }
`;

const DrawerContainer = styled.div`
  .MuiDrawer-paper {
    height: 100%;
  }
  .MuiCollapse-root {
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    margin: 0 0 2px;
  }
  .MuiCollapse-wrapperInner {
    padding: 4px 0;
    border-radius: 8px;
    overflow: hidden;
    background: #1594db;
  }
`;

export { Logo, ItemText, Blinking, LogoWrapper, DrawerContainer, NavDivider, NewBadge };
